/**
 * Make first letter of a string upper case
 * @param string
 */
export default function capitalizeFirstLetter(string: string): string {
  if (!string) return ''
  if (string === 'sole_trader') {
    return string.replace('_', ' ').replace(/\b[a-z]/g, (match: string) => match.toUpperCase())
  }
  return string.trim().charAt(0).toUpperCase() + string.trim().slice(1)
}
